import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

import BusinessSiteIdHelp from '../../../assets/images/restore_site_id.png';
import utils from '../../../lib/utils';

import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;
    this.state = {
      account: '',
      apiKey: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  onInputChange(event) {
    if(event.target.name!=='account'){
    this.setState({
      [event.target.name]: event.target.value,
    });
    }else if(utils.isPositiveInteger(event.target.value) || event.target.value===''){
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  onNextButtonClick() {
    const { account, apiKey } = this.state;

    const data = {
      client:'RESTORE',
      account,
      apiKey,
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
    }
  }

  validate(data) {
    if (!data.account || !data.apiKey) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { account, apiKey, mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save account information
            </p>
          ) : null}
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your Restore Site Id *</p>
            <input
              type="text"
              name="account"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={account}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>
          <a
            className="authorize-access__help-text"
            data-tip
            data-for="businesssiteidhelp"
          >
            How to find your Site Id?
          </a>
          <ReactTooltip
            id="businesssiteidhelp"
            className="authorize-access__help-tooltip"
          >
            <img src={BusinessSiteIdHelp} alt="Business Name" width="700" />
          </ReactTooltip>
          {/* <a className="authorize-access__help-text" data-tip data-for="locationidhelp">
                  Hint: Your Zenoti Account Name is the same as the leading
                  part of the URL for your Zenoti online account
          </a> */}

          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter a unique Restore API Key *</p>
            <input
              type="text"
              name="apiKey"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={apiKey}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

          {/* <a className="authorize-access__help-text" data-tip data-for="locationidhelp">
                  Hint: You can find instrutions on how to generate an API key
                  by going to the following link and referring to the Overview
          </a> */}

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};
